import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { notification } from 'antd'

import { api, get, put, getBranchOwner, consts } from "@config"
import { Form, FormControl, Button, ButtonGroup, Row, Col } from 'react-bootstrap'
import Input from '@inspinia-react/form/input/input'
import { setLoading } from "@inspinia-react/actions"

const crt = [
    {
        code: 1,
        description: "1 - Simples Nacional",
        value: "mei",
    },
    {
        code: 2,
        description: "2 - Simples Nacional - excesso de sublimite da receita bruta",
        value: "simples nacional mei",
    },
    {
        code: 3,
        description: "3 - Regime Normal",
        value: "regime normal"
    },
    {
        code: 4,
        description: "4 - Simples Nacional - MEI",
        value: "simples nacional"
    }
]

import AddressComponent from "@parts/address-component"


import {
    setPostalCode,
    setStateLocation,
    setCityLocation,
    setStreet,
    setStreetNumber,
    setComplement,
    setDistrict
} from "@parts/address-component/actions"

import {
    setBasePersonName,
    setBasePersonEmail,
    setBasePersonPhoneNumber
} from "@parts/base-person/actions"
import {
    setFancyName,
    setCRT,
    setCNAE,
    setStateRegistry,
    setMunicipalRegistry,
} from "@parts/company-data/actions"
import { checkIfBranchExists } from '../../../../utils'
import Cnae from '../../../parts/company-data/cnae'


function IndividualComponent(props) {

    const [name, email, phoneNumber] = props.values
    const [setBasePersonName, setBasePersonEmail, setBasePersonPhoneNumber] = props.actions
    const personCpf = props.data.individual.cpf

    React.useEffect(() => {
        setBasePersonName(props.data.name)
        setBasePersonEmail(props.data.email)
        setBasePersonPhoneNumber(props.data.phone_number)
    }, [])

    return <React.Fragment>
        <Row>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Nome
                    </Form.Label>
                    <FormControl
                        value={name}
                        onChange={e => setBasePersonName(e.target.value)} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        CPF
                    </Form.Label>
                    <FormControl disabled value={personCpf} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Telefone
                    </Form.Label>
                    <FormControl
                        value={phoneNumber}
                        onChange={e => setBasePersonPhoneNumber(e.target.value)} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        E-mail
                    </Form.Label>
                    <FormControl disabled value={email} onChange={e => setBasePersonEmail(e.target.value)} />
                </Form.Group>
            </Col>
        </Row>
    </React.Fragment>
}
function CompanyComponent(props) {
    const [setName, setEmail, setPhoneNumber] = props.actions
    const [fancyName, stateRegistry, municipalRegistry] = props.companyValues
    const [setFancyName, setCRT, setCNAE, setStateRegistry, setMunicipalRegistry] = props.companyActions
    const [name, email, phoneNumber] = props.values


    React.useEffect(() => {
        setName(props.data.name)
        setEmail(props.data.email)
        setPhoneNumber(props.data.phone_number)
        setFancyName(props.data.company.fancy_name)
        setStateRegistry(props.data.company.state_registry)
    }, [])

    return <React.Fragment>
        <Row>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Razão Social
                    </Form.Label>
                    <FormControl
                        value={name}
                        disabled={props.loading}
                        onChange={e => setName(e.target.value)} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Nome Fantasia
                    </Form.Label>
                    <FormControl
                        value={fancyName}
                        disabled={props.loading}
                        onChange={e => {
                            setFancyName(e.target.value)
                        }} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        CNPJ
                    </Form.Label>
                    <Input
                        mask="99.999.999/9999-99"
                        disabled={true}
                        value={props.data.company.cnpj} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        E-mail
                    </Form.Label>
                    <FormControl
                        disabled={props.loading}
                        onChange={e => setEmail(e.target.value)}
                        value={email} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Inscrição Estadual
                    </Form.Label>
                    <FormControl
                        value={stateRegistry}
                        disabled={props.loading}
                        onChange={e => setStateRegistry(e.target.value.replace(/[^a-zA-Z0-9 ]/g, ''))} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Inscrição Municipal
                    </Form.Label>
                    <FormControl
                        value={municipalRegistry}
                        disabled={props.loading}
                        onChange={e => setMunicipalRegistry(e.target.value)} />
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        Telefone
                    </Form.Label>
                    <Input
                        mask="(99) 99999-9999"
                        value={phoneNumber}
                        disabled={props.loading}
                        onChange={e => setPhoneNumber(e)} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>
                        CRT
                    </Form.Label>
                    <FormControl
                        disabled={props.loading}
                        as="select"
                        onChange={e => {
                            const { value } = e.target
                            let [code, description] = value.split(":")
                            setCRT({
                                code,
                                description: description.toLowerCase()
                            })
                        }} >
                        {
                            crt.map((item, x) => <option
                                selected={props.data.crt_description === item.description.toLowerCase()}
                                key={x}
                                value={`${item.code}:${item.description}`}>
                                {item.description}
                            </option>)
                        }
                    </FormControl>
                </Form.Group>
            </Col>
            <Cnae default={props.data.company.cnae} />
        </Row>
    </React.Fragment>
}
class CompanyData extends React.Component {

    constructor(props) {
        super(props)
        checkIfBranchExists()
        this.branch = getBranchOwner()
    }
    save() {
        this.props.setLoading(true)
        const data = {
            "name": this.props.name,
            "phone_number": this.props.phoneNumber,
            "email": this.props.email
        }

        data.branch = {}
        data.branch.crt = this.props.crt.crt.code
        data.branch.crt_description = this.props.crt.crt.description
        data.branch.main_company = this.branch.main_company
        data.branch.aliquota_credito = 1

        if (this.branch.branch_type != 1 && this.branch.company) {
            data["company"] = {}
            data.company.cnpj = this.branch.company.cnpj
            data.company.state_registry = this.props.stateRegistry
            data.company.municipal_registry = this.props.municipalRegistry
            data.company.fancy_name = this.props.fancyName || this.props.name
            data.branch.is_fiscal = this.branch.is_fiscal
            if (this.props.cnae && this.props.cnae.length > 12) {
                data.company.main_cnae = this.props.cnae
            }
        } else {
            data.individual = {}
            data.individual.cpf = this.branch.individual.cpf
            data.branch.is_fiscal = false
        }
        data.address = {
            city_location: this.props.cityLocation.value,
            state_location: this.props.stateLocation.value,
            street: this.props.street,
            district: this.props.district,
            complement: this.props.complement,
            street_number: this.props.streetNumber,
            postal_code: this.props.postalCode
        }

        const payload = resp => {
            window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(resp))
            window.clientAPI._setCookie('branch_owner_id', resp.id)
            window.clientAPI._setCookie('branch_owner_name', resp.individual ? resp.name : resp.company.fancy_name)
            window.clientAPI._setCookie('branch_state_name', resp.address.state)
            notification.open({
                type: "success",
                message: "Dados atualizados",
                duration: 2,
                key: 98
            })
            setTimeout(() => {
                window.location.reload()
            }, 2000)
        }
        const errorPayload = errors => {
            this.props.setLoading(false)
        }
        put(`${api.branches}${this.branch.id}/`, data, payload, errorPayload)
    }
    UNSAFE_componentWillMount() {
        const { props } = this;

        setTimeout(() => {
            props.setBasePersonName(this.branch.name)
            props.setBasePersonEmail(this.branch.email)
            props.setBasePersonPhoneNumber(this.branch.phone_number)
            props.setCRT(this.branch.crt)

            if (this.branch.branch_type != 1 && this.branch.company) {
                props.setFancyName(this.branch.company.fancy_name)
                props.setCNAE(this.branch.company.cnae.code)
                props.setStateRegistry(this.branch.company.state_registry)
                props.setMunicipalRegistry(this.branch.company.municipal_registry)
            }

            props.setStateLocation({ value: this.branch.address.state_id, label: this.branch.address.state })
            props.setCityLocation({ value: this.branch.address.city_id, label: this.branch.address.city })
            props.setPostalCode(this.branch.address.postal_code)
            props.setStreet(this.branch.address.street)
            props.setStreetNumber(this.branch.address.street_number)
            props.setComplement(this.branch.address.complement)
            props.setDistrict(this.branch.address.district)
        }, 300)
    }
    redirectToSendNotes() {
        window.location.href = '/branches/create/?change-individual-to-company'
    }
    render() {
        return <React.Fragment>
            <div className="py-2">
                {this.branch.branch_type != 1 && this.branch.company
                    ? <CompanyComponent
                        loading={this.props.loading}
                        data={this.branch}
                        actions={[
                            this.props.setBasePersonName,
                            this.props.setBasePersonEmail,
                            this.props.setBasePersonPhoneNumber
                        ]}
                        values={[
                            this.props.name,
                            this.props.email,
                            this.props.phoneNumber,
                            this.props.doc
                        ]}
                        companyActions={[
                            this.props.setFancyName,
                            this.props.setCRT,
                            this.props.setCNAE,
                            this.props.setStateRegistry,
                            this.props.setMunicipalRegistry
                        ]}
                        companyValues={[
                            this.props.fancyName,
                            this.props.stateRegistry,
                            this.props.municipalRegistry,
                            this.props.crt,
                            this.props.cnae
                        ]}
                    />
                    : <IndividualComponent
                        data={this.branch}
                        actions={[
                            this.props.setBasePersonName,
                            this.props.setBasePersonEmail,
                            this.props.setBasePersonPhoneNumber
                        ]}
                        values={[
                            this.props.name,
                            this.props.email,
                            this.props.phoneNumber,
                            this.props.doc
                        ]}
                    />
                }
                {
                    !this.branch.is_fiscal
                        ? <button
                            onClick={this.redirectToSendNotes}
                            className="btn btn-primary btn-sm"
                        >
                            Emitir notas
                        </button>
                        : null
                }
                <hr />
                <p className="lead">Endereço</p>
                <AddressComponent viacep />
                <ButtonGroup className="py-2">
                    <Button variant="danger" onClick={() => window.history.back()}>
                        Cancelar
                    </Button>
                    <Button onClick={this.save.bind(this)} >
                        Salvar
                    </Button>

                </ButtonGroup>
            </div>
        </React.Fragment>
    }

    componentWillUnmount() {
        setTimeout(() => {

            const { props } = this;

            props.setBasePersonName("")
            props.setBasePersonEmail("")
            props.setBasePersonPhoneNumber("")
            props.setFancyName("")
            props.setCRT("")
            props.setCNAE("")
            props.setStateRegistry("")
            props.setMunicipalRegistry("")

            props.setPostalCode("")
            props.setStateLocation("")
            props.setCityLocation("")

            props.setStreet("")
            props.setStreetNumber("")
            props.setComplement("")
            props.setDistrict("")
        }, 300)
    }
}

const mapStateToProps = state => ({
    loading: state.loading,
    name: state.basePersonName,
    email: state.basePersonEmail,
    phoneNumber: state.basePersonPhone,

    fancyName: state.fancyName,
    crt: state.crt,
    cnae: state.cnae,
    stateRegistry: state.stateRegistry,
    municipalRegistry: state.municipalRegistry,

    cityLocation: state.cityLocation,
    stateLocation: state.stateLocation,
    street: state.street,
    district: state.district,
    complement: state.complement,
    streetNumber: state.streetNumber,
    postalCode: state.postalCode
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setPostalCode,
    setBasePersonName,
    setBasePersonEmail,
    setBasePersonPhoneNumber,
    setFancyName,
    setCRT,
    setCNAE,
    setStateRegistry,
    setMunicipalRegistry,
    setStateLocation,
    setCityLocation,
    setStreet,
    setStreetNumber,
    setComplement,
    setDistrict,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(CompanyData)


// WEBPACK FOOTER //
// ./src/components/pages/settings/branch-config/index.jsx